module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }} </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=nav-btn-box> <button @click=yesAction type=button class=\"prev-btn basic-bg\">{{ translations['Yes'] }}</button> <button @click=noAction class=\"next-btn basic-bg\" type=button>{{ translations['No'] }}</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Contrastjumper.vue
// module id = 66
// module chunks = 1